import { Box, Text } from '@chakra-ui/react'

interface GridModalHeaderIProps {
  title?: string
  subtitle?: string
}

export const GridModalHeader = ({
  title = 'Camera Grids',
  subtitle = 'Configure camera grids to enable features such as Tailgating and AI Operator',
}: GridModalHeaderIProps) => (
  <Box alignItems='center' display='flex' mb={5}>
    <Box ml={2}>
      <Text color='#172B4D' fontSize='25px' fontWeight='bold'>
        {title}
      </Text>
      <Text color='#172B4D' fontSize='14px' fontWeight={500}>
        {subtitle}
      </Text>
    </Box>
  </Box>
)
